import Vue from 'vue'
import axios from 'axios'
import { UsersService } from '@/services/sso-users.service.js'
import { store } from './store'
import { EventBus } from '@/event-bus'

let auth = new Vue({
  data() {
    return {
      ssoService: new UsersService(),
      accessToken: localStorage.getItem('access_token'),
      tokenType: localStorage.getItem('token_type'),
      refreshToken: localStorage.getItem('refresh_token'),
      expiresAt: localStorage.getItem('expires_at'),
      user: localStorage.getItem('user'),
    }
  },
  methods: {
    setAccessToken(accessToken) {
      localStorage.setItem('access_token', accessToken)
      this.accessToken = accessToken
    },
    setTokenType(tokenType) {
      localStorage.setItem('token_type', tokenType)
      this.tokenType = tokenType
    },
    setRefreshToken(refreshToken) {
      localStorage.setItem('refresh_token', refreshToken)
      this.refreshToken = refreshToken
    },
    setExpiresAt(expiresIn) {
      let expiresAt = JSON.stringify(expiresIn * 1000 + new Date().getTime())
      localStorage.setItem('expires_at', expiresAt)
      this.expiresAt = expiresAt
    },
    setUser(user) {
      localStorage.setItem('user', JSON.stringify(user))
      this.user = user
    },
    login() {
      window.location.replace(
        process.env.VUE_APP_SSO_API_URL +
          '/oauth2/authorize?client_id=' +
          process.env.VUE_APP_SSO_APP_ID +
          '&scope=offline_access' +
          '&response_type=code&redirect_uri=' +
          process.env.VUE_APP_SSO_REDIRECT_URL
      )
    },
    async logout() {
      try {
        await this.ssoService.logout(process.env.VUE_APP_SSO_APP_ID)
        localStorage.removeItem('access_token')
        localStorage.removeItem('token_type')
        localStorage.removeItem('expires_at')
        localStorage.removeItem('user')
        localStorage.removeItem('refresh_token')
        localStorage.removeItem('vuex')
        window.location.replace(
          process.env.VUE_APP_SSO_API_URL +
            '/oauth2/authorize?client_id=' +
            process.env.VUE_APP_SSO_APP_ID +
            '&scope=offline_access' +
            '&response_type=code&redirect_uri=' +
            process.env.VUE_APP_SSO_REDIRECT_URL
        )
      } catch (e) {
        EventBus.$emit('errors', {
          errors: 'sso',
          displayRefreshBtn: true,
        })
      }
    },
    async isAuthenticated() {
      if (this.accessToken) {
        try {
          await this.ssoService.validateToken()
          return true
        } catch (e) {
          return await this.handleRefreshToken()
        }
      }
      return await this.logout()
    },
    async handleRefreshToken() {
      if (this.accessToken && this.refreshToken) {
        try {
          const token = await this.ssoService.requestToken({
            client_id: process.env.VUE_APP_SSO_APP_ID,
            grant_type: 'refresh_token',
            refresh_token: this.refreshToken,
            access_token: this.accessToken,
          })

          if (typeof token === 'object' || !JSON.parse(token).error) {
            this.setAccessToken(token.access_token)
            this.setExpiresAt(token.expires_in)
            this.setUser(token.userId)
            this.setTokenType(token.token_type)
            await store.dispatch('setFusionAuthToken', token)
            return true
          }
          return await this.logout()
        } catch (e) {
          EventBus.$emit('errors', {
            errors: 'sso',
            displayRefreshBtn: true,
          })
          return false
        }
      } else {
        return false
      }
    },
    async handleAuthentication(code) {
      let token

      try {
        // Default Oauth2 Auth
        token = await this.ssoService.requestToken({
          client_id: process.env.VUE_APP_SSO_APP_ID,
          code: code,
          grant_type: 'authorization_code',
          scope: 'offline_access',
          redirect_uri: process.env.VUE_APP_SSO_REDIRECT_URL,
        })
      } catch (e) {
        EventBus.$emit('errors', {
          errors: 'sso',
          displayRefreshBtn: true,
        })
        return false
      }

      if (typeof token === 'object' || !JSON.parse(token).error) {
        this.setRefreshToken(token.refresh_token)
        this.setAccessToken(token.access_token)
        this.setExpiresAt(token.expires_in)
        this.setUser(token.userId)
        this.setTokenType(token.token_type)

        let myInit = {
          headers: {
            Authorization: 'Bearer ' + token.access_token,
          },
        }
        let user
        try {
          user = await this.$Amplify.API.get('users', '/user/' + token.userId, myInit)
        } catch (error) {
          console.error(error)
          /*EventBus.$emit('errors', {
            error: 'notAuthorized',
            displayLogoutBtn: true,
          })*/
          throw error
        }

        if (user.user.email) {
          await store.dispatch('setUserEmail', user.user.email)
        } else {
          await store.dispatch('setUserEmail', null)
        }

        if (user.user.username) {
          await store.dispatch('setUsername', user.user.username)
        } else {
          await store.dispatch('setUsername', null)
        }

        if (user.user.memberships) {
          let groupId = user.user.memberships[0].groupId
          let group = await this.$Amplify.API.get('users', '/group/' + groupId, myInit)
          await store.dispatch('setCurrentGroup', group.group)
        }
        await store.dispatch('setCurrentStore', undefined)
        await store.dispatch('setCurrentStoreDetails', undefined)
        await store.dispatch('setUserStores', [])
        if (user.user.data) {
          if (user.user.data.userStore || user.user.data.main_location) {
            let currentStore = user.user.data.main_location || user.user.data.userStore
            await store.dispatch('setCurrentStore', currentStore)
          }
          if (user.user.data.other_locations) {
            await store.dispatch('setUserStores', user.user.data.other_locations)
          }
        }

        // Reset unified stock role
        await store.dispatch('setRolesUnifiedStock', 'store-stock-viewer')

        // Create all store data for user and group
        await store.dispatch('setFusionAuthToken', token)
        for (let index = 0; index < user.user.registrations.length; index++) {
          if (user.user.registrations[index].applicationId === process.env.VUE_APP_SSO_APP_ID) {
            await store.dispatch('setRoles', user.user.registrations[index].roles)
            if (user.user.registrations[index].roles.includes('octipas-admin')) {
              await store.dispatch('setIsShopManager', true)
              await store.dispatch('setIsCustomerService', true)
              await store.dispatch('setIsAdmin', true)
              await store.dispatch('setIsOctipasAdmin', true)
            } else if (user.user.registrations[index].roles.includes('oms-admin')) {
              await store.dispatch('setIsShopManager', true)
              await store.dispatch('setIsCustomerService', true)
              await store.dispatch('setIsAdmin', true)
              await store.dispatch('setIsOctipasAdmin', false)
            } else if (user.user.registrations[index].roles.includes('oms-customer-service')) {
              await store.dispatch('setIsShopManager', true)
              await store.dispatch('setIsCustomerService', true)
              await store.dispatch('setIsAdmin', false)
              await store.dispatch('setIsOctipasAdmin', false)
            } else if (user.user.registrations[index].roles.includes('oms-shop-manager')) {
              await store.dispatch('setIsShopManager', true)
              await store.dispatch('setIsCustomerService', false)
              await store.dispatch('setIsAdmin', false)
              await store.dispatch('setIsOctipasAdmin', false)
            } else if (user.user.registrations[index].roles.includes('default-user')) {
              await store.dispatch('setIsShopManager', false)
              await store.dispatch('setIsCustomerService', false)
              await store.dispatch('setIsAdmin', false)
              await store.dispatch('setIsOctipasAdmin', false)
            }
          } else if (user.user.registrations[index].applicationId === process.env.VUE_APP_UNIFIED_STOCK_SSO_APP_ID) {
            // Set unified stock roles
            await store.dispatch('setRolesUnifiedStock', user.user.registrations[index].roles[0])
          } else if (user.user.registrations[index].applicationId === process.env.VUE_APP_OCTI_STOCK_SSO_APP_ID) {
            await store.dispatch('setRolesOctiStock', user.user.registrations[index].roles[0])
          } else if (user.user.registrations[index].applicationId === process.env.VUE_APP_ANALYTICS_SSO_APP_ID) {
            await store.dispatch('setRolesAnalytics', user.user.registrations[index].roles[0])
          }
        }

        // Check AI status
        axios
          .get(`${process.env.VUE_APP_AI_SERVICES_URL}/users/me`, {
            headers: {
              Authorization: 'Bearer ' + token.access_token,
            },
          })
          .then(async (response) => {
            const aiEnabled = response.status === 200
            await store.dispatch('setAiEnabled', aiEnabled)
          })
      } else {
        this.logout()
      }
    },
  },
})

export default {
  install: function (Vue) {
    Vue.prototype.$auth = auth
  },
}
